import { BOOKING_APIS } from "@/api_framework/api_config";
import { IBookingCountListResponse } from "@/api_framework/api_modals/Bookings";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";

import { setLoading } from "@/app_redux/reducers/loading_reducer";
import { setBookingCountList } from "@/app_redux/reducers/slices/auth/customer_profile_slice";
import axios, { AxiosError, AxiosResponse } from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback } from "react";
import toast from "react-hot-toast";
import { useConfiguration } from "../../useConfiguration";
import { useCurlLogger } from "../../useCurlLogger";

AxiosCurlirize(axios, () => {});
export const useUserBookingsCountListAPI = () => {
  const configuration = useConfiguration();
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();
  const toggleLoading = (toggleState: boolean) => {
    dispatch(
      setLoading({
        key: "isCustomerBookingsFetchInProgress",
        status: toggleState,
      }),
    );
  };
  const execute = useCallback(
    async (userId: string) => {
      toggleLoading(true);
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);

        await axios
          .get(BOOKING_APIS?.APPOINTMENT_COUNT?.baseURL ?? "", {
            params: {
              user_id: userId,
            },
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<IBookingCountListResponse>) => {
            toggleLoading(false);
            if (res.data.status === true && res.data) {
              dispatch(
                setBookingCountList({
                  data: res.data.data,
                }),
              );
            } else {
              dispatch(
                setBookingCountList({
                  data: null,
                }),
              );
            }
          })
          .catch((e: AxiosError) => {
            sendCurl(e.config["curlCommand"]);
            dispatch(
              setBookingCountList({
                data: null,
              }),
            );
            toggleLoading(false);
            if (e.response.status === 400) {
              //
            }
          });
      } catch (e: any) {
        toast.error("Server Error: " + e.message);
      }
    },
    [dispatch],
  );
  return execute;
};
